/**
 *
 * @module entry
 * @desc {SDK.Media} entry point.
 *
 */

import AdEngine from './adEngine/entry';
import MediaApi from './mediaApi';
import MediaManager from './mediaManager';
import PlayerAdapter from './playerAdapter';
import MediaCapabilitiesProvider from './mediaCapabilitiesProvider';
import MediaDescriptor from './mediaDescriptor';
import HdrType from './hdrType';
import PlaybackSession from './playbackSession';
import AdInsertionStrategy from './adInsertionStrategy';
import ThumbnailResolution from './thumbnailResolution';

import AuthCookieProvider from './authCookieProvider';
import MediaAnalyticsKey from './mediaAnalyticsKey';
import MediaItem from './mediaItem';
import MediaPlayhead from './mediaPlayhead';
import MediaPlayheadStatus from './mediaPlayheadStatus';
import Playlist from './playlist';
import PlaybackAttributes from './playbackAttributes';
import PlaylistType from './playlistType';

import PlaybackTelemetryDispatcher from './playbackTelemetryDispatcher';
import PlaybackEventListener from './playbackEventListener';
import PlaybackMetricsProvider from './playbackMetricsProvider';
import PlaybackMetrics from './playbackMetrics';
import PlaybackTelemetryConfiguration from './playbackTelemetryConfiguration';

import BamWebPlayerAdapter from './playerAdapter/bamWebPlayerAdapter';
import TrilithiumPlayerAdapter from './playerAdapter/trilithiumPlayerAdapter';
import Html5PlayerAdapter from './playerAdapter/html5PlayerAdapter';
import HlsJsPlayerAdapter from './playerAdapter/hlsJsPlayerAdapter';
import CafPlayerAdapter from './playerAdapter/cafPlayerAdapter';
import ChromecastPlayerAdapter from './playerAdapter/chromecastPlayerAdapter';
import SamsungOrsayPlayerAdapter from './playerAdapter/samsungOrsayPlayerAdapter';
import SamsungTizenPlayerAdapter from './playerAdapter/samsungTizenPlayerAdapter';
import AtvPlayerAdapter from './playerAdapter/atvPlayerAdapter';
import BamHlsPlayerAdapter from './playerAdapter/bamHlsPlayerAdapter';
import DssWebPlayerAdapter from './playerAdapter/dssWebPlayerAdapter';

/**
 *
 * @typedef SDK.Media
 * @type {Object}
 *
 * @property {AdEngine} AdEngine
 * @property {MediaApi} MediaApi
 * @property {MediaManager} MediaManager
 * @property {PlayerAdapter} PlayerAdapter
 * @property {MediaCapabilitiesProvider} MediaCapabilitiesProvider
 * @property {MediaDescriptor} MediaDescriptor
 * @property {HdrType} HdrType
 * @property {PlaybackSession} PlaybackSession
 * @property {AdInsertionStrategy} AdInsertionStrategy
 * @property {ThumbnailResolution} ThumbnailResolution
 *
 * @property {AuthCookieProvider} AuthCookieProvider
 * @property {MediaAnalyticsKey} MediaAnalyticsKey
 * @property {MediaItem} MediaItem
 * @property {MediaPlayhead} MediaPlayhead
 * @property {MediaPlayheadStatus} MediaPlayheadStatus
 * @property {Playlist} Playlist
 * @property {PlaybackAttributes} PlaybackAttributes
 * @property {PlaylistType} PlaylistType
 *
 * @property {PlaybackTelemetryDispatcher} PlaybackTelemetryDispatcher
 * @property {PlaybackEventListener} PlaybackEventListener
 * @property {PlaybackMetricsProvider} PlaybackMetricsProvider
 * @property {PlaybackMetrics} PlaybackMetrics
 * @property {PlaybackTelemetryConfiguration} PlaybackTelemetryConfiguration
 *
 */

/**
 *
 * @typedef SDK.Media.PlayerAdapter
 * @type {PlayerAdapter}
 *
 * @property {AtvPlayerAdapter} AtvPlayerAdapter
 * @property {BamWebPlayerAdapter} BamWebPlayerAdapter
 * @property {TrilithiumPlayerAdapter} TrilithiumPlayerAdapter
 * @property {Html5PlayerAdapter} Html5PlayerAdapter
 * @property {HlsJsPlayerAdapter} HlsJsPlayerAdapter
 * @property {CafPlayerAdapter} CafPlayerAdapter
 * @property {ChromecastPlayerAdapter} ChromecastPlayerAdapter
 * @property {SamsungOrsayPlayerAdapter} SamsungOrsayPlayerAdapter
 * @property {SamsungTizenPlayerAdapter} SamsungTizenPlayerAdapter
 * @property {BamHlsPlayerAdapter} BamHlsPlayerAdapter
 * @property {DssWebPlayerAdapter} DssWebPlayerAdapter
 *
 */

/**
 *
 * @type {SDK.Media}
 *
 */
export default {

    AdEngine,
    MediaApi,
    MediaManager,
    /**
     *
     * @type {SDK.Media.PlayerAdapter}
     *
     */
    PlayerAdapter: Object.assign(PlayerAdapter, {
        AtvPlayerAdapter,
        BamWebPlayerAdapter,
        TrilithiumPlayerAdapter,
        Html5PlayerAdapter,
        HlsJsPlayerAdapter,
        CafPlayerAdapter,
        ChromecastPlayerAdapter,
        SamsungOrsayPlayerAdapter,
        SamsungTizenPlayerAdapter,
        BamHlsPlayerAdapter,
        DssWebPlayerAdapter
    }),
    MediaCapabilitiesProvider,
    MediaDescriptor,
    HdrType,
    PlaybackSession,
    AdInsertionStrategy,
    ThumbnailResolution,

    AuthCookieProvider,
    MediaAnalyticsKey,
    MediaItem,
    MediaPlayhead,
    MediaPlayheadStatus,
    Playlist,
    PlaybackAttributes,
    PlaylistType,

    PlaybackTelemetryDispatcher,
    PlaybackEventListener,
    PlaybackMetricsProvider,
    PlaybackMetrics,
    PlaybackTelemetryConfiguration

};



// WEBPACK FOOTER //
// ./src/media/entry.js